import UseCase, { NoParams } from "../../core/useCase/UseCase";
import { SessionRepository } from "../repository/SessionRepository";

/**
 * Clears the idle clock on sign-out, so a stale timestamp is not read as
 * recent input by the next member to sign in on the same browser. Called from
 * useAuth.logout(), the single funnel every sign-out path already uses.
 *
 * Deliberately does not clear the session-ended reason: the idle path writes
 * that immediately before signing out, and /login still needs to read it.
 */
export default class ClearSessionActivity extends UseCase<void, NoParams> {
  repository: SessionRepository;

  constructor(repository: SessionRepository) {
    super();
    this.repository = repository;
  }

  execute = () => this.repository.clearActivity();
}
